// extracted by mini-css-extract-plugin
module.exports = {"root":"_ee13fff","image":"_b310f84"};